<template>
  <v-container>
    <div class="title d-flex flex-column justify-center align-center mt-12">
      <img src="@core/assets/images/no_access_lock.png">
      <p class=" mt-5 mb-1 secondary--font font-weight-600" v-html="message"></p>
      <p class="body-2">
        Please talk to your Customer Success Manager to enable this function.
      </p>
    </div>
  </v-container>
</template>
<script>
import { $accounts } from '@core/services';
import { mapGetters } from 'vuex';
import { sanitiseAccountList } from '@core/config/utils';
export default {
  name: "MAppDenied",
  computed: {
    ...mapGetters({
      account: 'auth/account',
      userAccess: 'auth/userAccess'
    }),
    message: function(){
      let product = window.location.pathname.split('/')[1];
      if(product != 'service' && product != 'commerce'){
          product = 'marketing'
      }
      return `This Account Doesn't have access to <span class="text-capitalize">${product}</span> Cloud App.`
    }
  },
  mounted(){
    this.fetchAccount()
  },
  methods: {
    fetchAccount(){
      $accounts.fetch({
        params: {
          id_eq: this.account.current.id
        }
      }).then((response)=>{
        let data = response.data.data;
        if(data.length){
          let accountNew = sanitiseAccountList(data)[0]
          this.updateAccount(accountNew)
        }
      })
    },
    updateAccount(accountNew){
      let accList = this.account.list
      let index = accList.findIndex(i=>i.id==this.account.current.id)
      let account = accList.find(i=>i.id==this.account.current.id)
      Object.assign(account, accountNew)
      accList.splice(index, 1, account)
      this.$store.commit("auth/account.list", accList);
      this.$store.commit("auth/account.id",this.account.current.id)
      if(
        (process.env.VUE_APP_PRODUCT == 'Marketing' && account.enable_marketing && this.userAccess.haveMarketingRole) ||
        (process.env.VUE_APP_PRODUCT == 'Service' && account.enable_service && this.userAccess.haveServiceRole)
      ){
        this.$router.replace({name:'dashboard'})
      }
    }
  }
}
</script>